import PropTypes from "prop-types";
import MUSnackbar from "@material-ui/core/Snackbar";
import Alert from "../Alert";

function Snackbar({
  text,
  open,
  onClose,
  severity,
  autoHideDuration,
  anchorOrigin,
  style,
}) {
  const alertStyle = { maxWidth: 650, wordBreak: "break-word", ...style };

  return open ? (
    <MUSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      style={{ height: "auto" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        style={
          severity === "info"
            ? { ...alertStyle, backgroundColor: "#5e72e4" }
            : alertStyle
        }
      >
        {text}
      </Alert>
    </MUSnackbar>
  ) : null;
}

Snackbar.defaultProps = {
  autoHideDuration: 6000,
  anchorOrigin: { vertical: "top", horizontal: "center" },
  severity: "info",
  text: "",
  open: false,
};

Snackbar.propTypes = {
  /**
   * Conteúdo que será exibido
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * Snackbar aberta ou não
   */
  open: PropTypes.bool,
  /**
   * Função que será executada ao fechar o snackbar
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Tipo/severidade do Snackbar. Essa propriedade define a cor e o item usado (ver na documentaçao do Material).
   */
  severity: PropTypes.string.isRequired,
  /**
   * Tempo para o Snack fechar automaticamente. Default 6000
   */
  autoHideDuration: PropTypes.number,
  anchorOrigin: PropTypes.object,
};

export default Snackbar;
